"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 * @global dataLayer
 */
window.dataLayer = window.dataLayer || [];

/**
 * https://developers.google.com/tag-manager/enhanced-ecommerce#checkoutfunnel
 */
var Track = /*#__PURE__*/function () {
  function Track() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Track);
    var defaultOptions = {
      currency: "CHF",
      affiliation: window.location.host,
      list: "Default"
    };
    this.options = Object.assign({}, defaultOptions, options);
  }
  _createClass(Track, [{
    key: "clearEcommerceObject",
    value: function clearEcommerceObject() {
      dataLayer.push({
        ecommerce: null
      });
    }
    /**
     * Measures product impressions and also tracks a standard
     * pageview for the tag configuration.
     * Product impressions are sent by pushing an impressions object
     * containing one or more impressionFieldObjects.
     *
     * @param {array} - products
     */
  }, {
    key: "measureProductImpressions",
    value: function measureProductImpressions(products) {
      this.clearEcommerceObject();
      dataLayer.push({
        event: "view_item_list",
        ecommerce: {
          items: products
        }
      });
    }
  }, {
    key: "addProductToShoppingCart",
    value: function addProductToShoppingCart(products) {
      this.clearEcommerceObject();
      dataLayer.push({
        event: "select_item",
        ecommerce: {
          items: products
        }
      });
    }
  }, {
    key: "removeProductFromShoppingCart",
    value: function removeProductFromShoppingCart(products) {
      this.clearEcommerceObject();
      dataLayer.push({
        event: "remove_item",
        ecommerce: {
          items: products
        }
      });
    }
  }, {
    key: "trackPaymentMethod",
    value: function trackPaymentMethod(_ref) {
      var totalAmount = _ref.totalAmount,
        paymentMethod = _ref.paymentMethod,
        products = _ref.products;
      dataLayer.push({
        event: "add_payment_info",
        ecommerce: {
          currency: this.options.currency,
          value: totalAmount,
          payment_type: paymentMethod,
          items: products
        }
      });
    }

    /**
     * A function to handle a click on a checkout button. This function uses the eventCallback
     * data layer variable to handle navigation after the ecommerce data has been sent to Google Analytics.
     *
     * @param {array} - products
     */
  }, {
    key: "onCheckout",
    value: function onCheckout(_ref2) {
      var step = _ref2.step,
        totalAmount = _ref2.totalAmount,
        products = _ref2.products,
        paymentMethod = _ref2.paymentMethod;
      this.clearEcommerceObject();
      // initial checkout
      if (step === 1) {
        dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            items: products
          }
        });
      }
      // Payment method change
      if (step === 2) {
        this.trackPaymentMethod({
          totalAmount: totalAmount,
          paymentMethod: paymentMethod,
          products: products
        });
      }
    }

    /**
     * A function to handle a click leading to a checkout option selection.
     */
  }, {
    key: "onCheckoutOption",
    value: function onCheckoutOption(step, _ref3) {
      var totalAmount = _ref3.totalAmount,
        paymentMethod = _ref3.paymentMethod,
        products = _ref3.products;
      this.clearEcommerceObject();
      // Payment method change
      if (step === 2) {
        this.trackPaymentMethod({
          totalAmount: totalAmount,
          paymentMethod: paymentMethod,
          products: products
        });
      }
    }

    /**
     * Send transaction data with a pageview if available
     * when the page loads. Otherwise, use an event when the transaction
     * data becomes available.
     *
     * @param {array} - products
     * @param {string} - transactionId
     * @param {number} - revenue
     */
  }, {
    key: "measuringPurchase",
    value: function measuringPurchase(products, transationId, revenue) {
      dataLayer.push({
        event: "purchase",
        ecommerce: {
          transaction_id: transationId,
          value: revenue,
          currency: this.options.currency,
          items: products
        }
      });
    }
  }, {
    key: "push",
    value: function push(data) {
      dataLayer.push(data);
    }
  }, {
    key: "ecommercePush",
    value: function ecommercePush(data) {
      this.clearEcommerceObject();
      this.push(data);
    }
  }]);
  return Track;
}();
exports.default = Track;